import {
  OrderType,
  QBankStructureStatus,
  useSearchQBankStructuresLazyQuery,
} from '@exam-management/graphql';
import {
  FormSearchSelection,
  type FormSearchSelectionProps,
  type OptionSelectionProps,
} from '@shared/components';
import { useMemo } from 'react';
import { useFormContext, type FieldValues } from 'react-hook-form';

import { type AddQBankToQConfigGeneratorFormValues } from '../add-qbank-to-qconfig-generator-form';

interface FormSearchQBSSelectionProps<TFieldValues extends FieldValues>
  extends Omit<FormSearchSelectionProps<TFieldValues>, 'options'> {
  addedQBSIds: string[];
}

export default function SearchQBSSelection<TFieldValues extends FieldValues>(
  props: Readonly<FormSearchQBSSelectionProps<TFieldValues>>,
) {
  const { addedQBSIds } = props;
  const formContext = useFormContext<AddQBankToQConfigGeneratorFormValues>();

  const [searchQBS, { data: searchQBSResult, loading: isSearchQBSLoading }] =
    useSearchQBankStructuresLazyQuery({
      variables: {
        search: {
          status: [QBankStructureStatus.Published],
        },
        paging: {
          currentPage: 0,
          pageSize: 200, // REMARK: 200 is temporary solution to get all QBS
        },
        order: {
          field: 'code',
          type: OrderType.Asc,
        },
      },
      fetchPolicy: 'network-only',
    });

  const qbsOptions = useMemo(() => {
    const filteredQBS = (searchQBSResult?.qbsSearchQBankStructures.qBankStructures ?? []).filter(
      (qbs) => !addedQBSIds.includes(qbs.id),
    );

    return (
      filteredQBS.map(
        (qbs) =>
          ({
            label: `${qbs.code}: ${qbs.name}`,
            value: qbs.id,
          }) as OptionSelectionProps,
      ) ?? []
    );
  }, [searchQBSResult, addedQBSIds]);

  return (
    <FormSearchSelection
      {...props}
      label='เลือกคลังข้อสอบ'
      placeholder='เลือกคลังข้อสอบ'
      fullWidth
      options={qbsOptions}
      loading={isSearchQBSLoading}
      onOpen={() => searchQBS()}
      onChange={(...args) => {
        props?.onChange?.(...args);
        formContext.reset({
          ...formContext.getValues(),
          levelItems: {},
        });
      }}
    />
  );
}
